import React from 'react';
import { Cell } from 'react-table';

import { getEstimatedLossLabel } from '@trqk/utils';

// eslint-disable-next-line @typescript-eslint/ban-types -- react-table's types extend object so we must do so as well
interface EstimatedLossCellProps<D extends object> {
    cell: Cell<D, NumberRange>;
}

/**
 * Displays a range of dollar values, like `$1 - $5K`, using getEstimatedLossLabel to handle edge
 * cases.
 * @param props - {@link EstimatedLossCellProps}
 */
// eslint-disable-next-line @typescript-eslint/ban-types -- react-table's types extend object so we must do so as well
export function EstimatedLossCell<D extends object>({
    cell,
}: EstimatedLossCellProps<D>): JSX.Element | null {
    const max = cell?.value?.max ?? 0;
    const min = cell?.value?.min ?? 0;

    const label = getEstimatedLossLabel({
        max,
        min,
    });

    if (label === null) {
        return null;
    }

    return <div>{label}</div>;
}
